export const seriesId = [
  "c0_viviendas",
  "c0_otras_construcciones",
  "c0_maquinaria_y_equipo",
  "c0_equipo_de_transporte",
  "c0_stock_de_capital_neto",
  "c0_consumo_de_capital_fijo",
  "c1_viviendas",
  "c1_otras_construcciones",
  "c1_maquinaria_y_equipo",
  "c1_equipo_de_transporte",
  "c2_stock_de_capital_neto_pib",
  "c2_stock_de_capital_neto_pib_excluyendo_viviendas",
  "c3_consumo_de_capital_fijo_pib",
  "c3_tasa_de_depreciacion_ccf_como_stock_de_capital_neto",
  "c4_viviendas",
  "c4_otras_construcciones",
  "c4_maquinaria_y_equipo",
  "c4_equipo_de_transporte",
  "c4_total",
  "c5_viviendas",
  "c5_otras_construcciones",
  "c5_maquinaria_y_equipo",
  "c5_equipo_de_transporte",
  "c6_stock_de_capital_productivo",
  "c6_calidad_del_capital",
  "c6_input_de_capital",
  "c7_input_de_capital_hora_trabajada",
  "c8_viviendas",
  "c8_otras_construcciones",
  "c8_maquinaria_y_equipo",
  "c8_equipo_de_transporte",
  "c8_total"
]

export const seriesEsp = [
  "Viviendas (millones de euros corrientes)",
  "Otras construcciones (millones de euros corrientes)",
  "Maquinaria y equipo (millones de euros corrientes)",
  "Equipo de transporte (millones de euros corrientes)",
  "Stock de capital neto (millones de euros corrientes)",
  "Consumo de capital fijo (millones de euros corrientes)",
  "Viviendas (precios corrientes) (%)",
  "Otras construcciones (precios corrientes) (%)",
  "Maquinaria y equipo (precios corrientes) (%)",
  "Equipo de transporte (precios corrientes) (%)",
  "Stock de capital neto",
  "Stock de Capital Neto/PIB (excluyendo viviendas) ",
  "Consumo de Capital Fijo (% PIB)",
  "Tasa de Depreciación (CCF como % Stock de Capital Neto)",
  "Viviendas (millones de euros a precios de 2010)",
  "Otras construcciones (millones de euros a precios de 2010)",
  "Maquinaria y equipo (millones de euros a precios de 2010)",
  "Equipo de transporte (millones de euros a precios de 2010)",
  "Total (millones de euros a precios de 2010)",
  "Viviendas (composición)",
  "Otras construcciones (composición)",
  "Maquinaria y equipo (composición)",
  "Equipo de transporte (composición)",
  "Stock de Capital Productivo",
  "Calidad del Capital",
  "Input de Capital",
  "Input de Capital/hora trabajada",
  "Viviendas",
  "Otras construcciones",
  "Maquinaria y equipo",
  "Equipo de transporte",
  "Total"
]

export const seriesEng = [
  "Dwellings (million current Euro)",
  "Other constructions (million current Euro)",
  "Machinery and equipment (million current Euro)",
  "Transport equipment (million current Euro)",
  "Net capital stock (million current Euro)",
  "Consumption of fixed capital (million current Euro)",
  "Dwellings (current prices) (%)",
  "Other constructions (current prices) (%)",
  "Machinery and equipment (current prices) (%)",
  "Transport equipment (current prices) (%)",
  "Net capital stock",
  "Net capital stock / GDP (excluding dwellings) ",
  "Consumption of fixed capital (% GDP)",
  "Depreciation rate (CFC as % Net Capital Stock)",
  "Dwellings (million 2010 Euro)",
  "Other constructions (million 2010 Euro)",
  "Machinery and equipment (million 2010 Euro)",
  "Transport equipment (million 2010 Euro)",
  "Total (million 2010 Euro)",
  "Dwellings (composition)",
  "Other constructions (composition)",
  "Machinery and equipment (composition)",
  "Transport equipment (composition)",
  "Productive Capital Stock",
  "Capital quality",
  "Capital input",
  "Capital input / hour worked",
  "Dwellings",
  "Other constructions",
  "Machinery and equipment",
  "Transport equipment",
  "Total"
]

export const groupsEsp = [
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Stock de Capital Neto y Consumo de Capital Fijo, 1850-2019",
  "Composición del Stock de Capital Neto",
  "Composición del Stock de Capital Neto",
  "Composición del Stock de Capital Neto",
  "Composición del Stock de Capital Neto",
  "Ratio stock de capital neto/PIB",
  "Ratio stock de capital neto/PIB",
  "Consumo de Capital Fijo (CCF) (% PIB) y Tasa de Depreciación (CCF como % Stock de Capital Neto)",
  "Consumo de Capital Fijo (CCF) (% PIB) y Tasa de Depreciación (CCF como % Stock de Capital Neto)",
  "Stock de Capital Productivo",
  "Stock de Capital Productivo",
  "Stock de Capital Productivo",
  "Stock de Capital Productivo",
  "Stock de Capital Productivo",
  "Valor de los Servicios del Capital: Composición",
  "Valor de los Servicios del Capital: Composición",
  "Valor de los Servicios del Capital: Composición",
  "Valor de los Servicios del Capital: Composición",
  "Input de Capital, Stock de Capital Productivo y Calidad del Capital",
  "Input de Capital, Stock de Capital Productivo y Calidad del Capital",
  "Input de Capital, Stock de Capital Productivo y Calidad del Capital",
  "Profundización del Capital, 1850-2023",
  "Coste Unitario del Uso del Capital, 1850-2023",
  "Coste Unitario del Uso del Capital, 1850-2023",
  "Coste Unitario del Uso del Capital, 1850-2023",
  "Coste Unitario del Uso del Capital, 1850-2023",
  "Coste Unitario del Uso del Capital, 1850-2023",
]

export const groupsEng = [
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock and Consumption of Fixed Capital, 1850-2023",
  "Net Capital Stock Composition",
  "Net Capital Stock Composition",
  "Net Capital Stock Composition",
  "Net Capital Stock Composition",
  "Net Capital Stock/GDP Ratio",
  "Net Capital Stock/GDP Ratio",
  "Consumption of Fixed Capital (CFC) (% GPD) and Depreciation rate (CFC as % Net Capital Stock)",
  "Consumption of Fixed Capital (CFC) (% GPD) and Depreciation rate (CFC as % Net Capital Stock)",
  "Productive Capital Stock",
  "Productive Capital Stock",
  "Productive Capital Stock",
  "Productive Capital Stock",
  "Productive Capital Stock",
  "Capital Services Value: Composition",
  "Capital Services Value: Composition",
  "Capital Services Value: Composition",
  "Capital Services Value: Composition",
  "Capital Input, Productive Capital Stock, and Capital Quality ",
  "Capital Input, Productive Capital Stock, and Capital Quality ",
  "Capital Input, Productive Capital Stock, and Capital Quality ",
  "Capital Deepening, 1850-2019",
  "Unit Cost of Capital Services, 1850-2023",
  "Unit Cost of Capital Services, 1850-2023",
  "Unit Cost of Capital Services, 1850-2023",
  "Unit Cost of Capital Services, 1850-2023",
  "Unit Cost of Capital Services, 1850-2023",
]

export const unitsEng = [
  "Million current Euro",
  "Million current Euro",
  "Million current Euro",
  "Million current Euro",
  "Million current Euro",
  "Million current Euro",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "2010 Million Euro",
  "2010 Million Euro",
  "2010 Million Euro",
  "2010 Million Euro",
  "2010 Million Euro",
  "%",
  "%",
  "%",
  "%",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
]

export const unitsEsp = [
  "millones de euros corrientes",
  "millones de euros corrientes",
  "millones de euros corrientes",
  "millones de euros corrientes",
  "millones de euros corrientes",
  "millones de euros corrientes",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "%",
  "millones de euros a precios de 2010",
  "millones de euros a precios de 2010",
  "millones de euros a precios de 2010",
  "millones de euros a precios de 2010",
  "millones de euros a precios de 2010",
  "%",
  "%",
  "%",
  "%",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
  "2010=100",
]
